import { useAppState } from "@/components/AppStateProvider";
import Box from "@/components/Box";
import ModalWorkFlow from "@/components/ModalWorkflow";
import { OrganisationBasketListing } from "@/components/organisations/checkout/OrganisationBasketListing";
import SavePatientForm from "@/components/organisations/checkout/forms/SavePatientForm";
import {
  getMissingFieldsForPatient,
  getSavePatientEditableFields
} from "@/components/organisations/shared/PatientDetails";
import { useModalWorkFlow } from "@/contexts/ModalWorkFlowProvider";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";

function CreatePatient() {
  const { setPatientOnBasketLine } = useOrganisationBasketContext();
  const modalWorkflowApi = useModalWorkFlow();

  return (
    <Box px={[20]} maxWidth={760} mx="auto">
      <SavePatientForm
        key="create"
        handleSuccess={({ data }) => {
          setPatientOnBasketLine({
            id: modalWorkflowApi.state["creatingForLineItem"],
            patient: data.savePatientMutation.patient.patientProfile.pk
          });
          modalWorkflowApi.setView("basket");
        }}
      />
    </Box>
  );
}

function EditPatient() {
  const { state } = useModalWorkFlow();
  const { organisationPatientId } = state;
  const { organisation } = useOrganisationContext();
  const patient = organisation?.patients.find(p => p.id === organisationPatientId);
  const modalWorkflowApi = useModalWorkFlow();

  return (
    <Box px={[20]} maxWidth={760} mx="auto">
      <SavePatientForm
        key="edit"
        title="Edit Patient Details"
        data-component-name="EditPatientForm"
        editableFields={getSavePatientEditableFields(patient)}
        missingFields={getMissingFieldsForPatient(patient)}
        defaultValues={{
          id: patient.id,
          firstName: patient.patientProfile.user.firstName,
          lastName: patient.patientProfile.user.lastName,
          email: patient.patientProfile.user.email,
          sex: patient.patientProfile.gender,
          dateOfBirth: patient.patientProfile.dateOfBirth || "",
          requiresGuardianConsent: patient.requiresGuardianConsent,
          guardianFirstName: patient.patientProfile.guardian?.user.firstName || "",
          guardianLastName: patient.patientProfile.guardian?.user.lastName || "",
          guardianEmail: patient.patientProfile.guardian?.user.email || ""
        }}
        handleSuccess={({ data }) => {
          modalWorkflowApi.setView("basket");
        }}
      />
    </Box>
  );
}

export default function Basket() {
  const { practitionerBasketOpen: basketOpen, setPractitionerBasketOpen: setBasketOpen } =
    useAppState();

  const { hasUndismissedBasketErrorModal } = useOrganisationBasketContext();

  return (
    <ModalWorkFlow
      defaultView="basket"
      maxWidth={"min(calc(100% - 20px - 5.5vw), 1020px)"}
      closeButton
      headerProps={{
        p: [20, 20, 40]
      }}
      bg="white"
      show={basketOpen}
      close={() => {
        if (hasUndismissedBasketErrorModal) {
          // they must dismiss the modal containing this error first
          return;
        }
        setBasketOpen(false);
      }}
      mode={[
        "fullScreen",
        "fullScreen",
        {
          topRightPosition: {
            x: [20, 20, "max(calc((100% - 1538px) / 2), 20px)"],
            y: 104
          }
        }
      ]}
      maxHeight={[null, null, "calc(100vh - 124px)"]}
      // 80px is height from top, 20px gap to bottom
      borderRadius={[0, 0, 5]}
      data-component-name={"PractitionerBasket"}
    >
      <ModalWorkFlow.View index="basket">
        <Box maxWidth={760} mx="auto" pb={[60, 60, 120]} px={[20, 20, 40]}>
          <OrganisationBasketListing showCheckoutButton={true} showShipping={false} />
        </Box>
      </ModalWorkFlow.View>
      <ModalWorkFlow.View index="createPatient">
        <CreatePatient />
      </ModalWorkFlow.View>
      <ModalWorkFlow.View index="editPatient">
        <EditPatient />
      </ModalWorkFlow.View>
    </ModalWorkFlow>
  );
}
